module.exports = {
    apiURL: process.env.VUE_APP_API_URL,
    recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
    apiRoutes: {
        auth: process.env.VUE_APP_API_URL + '/auth/authorization/admin',
        refreshToken: process.env.VUE_APP_API_URL + '/auth/refresh',
        forgot: process.env.VUE_APP_API_URL + '/auth/forgot-pwd',
        resetPwd: process.env.VUE_APP_API_URL + '/auth/reset-pwd'
    }
}